import React from 'react'
import PageIntro from '../../components/PageIntro/PageIntro'
import PartnersTable from '../../components/Table/partner/PartnersTable'

/* Partners: schools, event hosts and individuals who bring talents and
   clients to Droomwork through their referral link. New registrations wait
   here (Pending) until someone checks them off-platform and verifies them on
   the partner's details page. */
const Partners = () => {
  return (
    <div className='mx-auto max-w-7xl space-y-6'>
      <PageIntro
        title={'Partners'}
        description={'Review new partner registrations, verify them, and see how many people each partner has brought.'}
      />
      <PartnersTable />
    </div>
  )
}

export default Partners
